import type { FunctionComponent, MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@trello/nachos/button';

import styles from './GenerateApiKeyModal.less';

export const GenerateApiKeyModal: FunctionComponent<{
  generateApiKey: (
    key: string | null,
  ) => MouseEventHandler<HTMLButtonElement> | undefined;
  hide: () => void;
}> = ({ generateApiKey, hide }) => {
  return (
    <div className={styles.modal}>
      <div className={styles.modalHeader}>
        <h1>
          <FormattedMessage
            id="templates.app_management.generate-api-key"
            defaultMessage="Generate API key"
            description="Title for the modal to generate an API key"
          />
        </h1>
      </div>
      <div className={styles.modalBody}>
        <p>
          <FormattedMessage
            id="templates.app_management.generating-a-unique-api-key"
            defaultMessage="Generating a unique API key will replace the API key used for <a>Personal Data Storage and GDPR compliance.</a>"
            description="Explanation of what generating a new API key will do"
            values={{
              a: (chunks) => (
                <a href="https://developer.atlassian.com/cloud/trello/guides/compliance/personal-data-storage-gdpr/">
                  {chunks}
                </a>
              ),
            }}
          />
        </p>
        <p>
          <FormattedMessage
            id="templates.app_management.fourteen-to-update-api-key"
            defaultMessage="You’ll have 14 days to update your API keys anywhere they are used to ensure your Power-Up remains in compliance."
            description="Information about the 14-day period to update API keys"
          />
        </p>
      </div>
      <div className={styles.modalFooter}>
        <Button onClick={hide}>
          <FormattedMessage
            id="templates.app_management.cancel"
            defaultMessage="Cancel"
            description="Button to cancel the API key generation process"
          />
        </Button>
        <Button
          className={styles.generateBtn}
          children={
            <FormattedMessage
              id="templates.app_management.generate-api-key"
              defaultMessage="Generate API key"
              description="Button to generate a new API key"
            />
          }
          appearance="primary"
          onClick={generateApiKey(null)}
        />
      </div>
    </div>
  );
};
